module.exports = __webpack_public_path__ + "static/img/hero-info-5.e788c23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web-firehero/tw/pc/imgs/hero-info-5.png
// module id = Xk/T
// module chunks = 13